import { makeAutoObservable } from 'mobx';
import { createContext, useContext } from 'react';

class TranslationsStore {
    private PTS_PKG = 'okny2025';
    locale: string = '';
    translations: Record<string, string> = {};

    constructor(locale: string) {
        this.locale = locale;
        makeAutoObservable(this);
    }

    private plural(value: number) {
        const valueLocal = Math.abs(value);

        if (valueLocal % 10 === 1 && valueLocal % 100 !== 11) {
            return 0;
        }

        if (2 <= valueLocal % 10 && valueLocal % 10 <= 4 && Math.floor((valueLocal % 100) / 10) !== 1) {
            return 1;
        }

        return 2;
    }

    get translate(): (key: string, params?: Record<string, string | number>, fallback?: string) => string {
        return (key, params, fallback) => {
            const translation = this.translations[key] || fallback || key;
            if (translation) {
                const result = params
                    ? Object.keys(params).reduce((acc, paramKey) => {
                          if (paramKey === 'countPlural') {
                              return acc.replace(/\[countPlural:(.+)\]/g, (found, optionsRaw) => {
                                  const options = optionsRaw.split('|');
                                  const counter = +params[paramKey];
                                  const id = this.plural(counter);
                                  const option = options[id];
                                  return option;
                              });
                          }

                          return acc.replace(new RegExp(`\\[${paramKey}\\]`, 'g'), '' + params[paramKey]);
                      }, translation)
                    : translation;

                return result;
            }

            return translation;
        };
    }

    get ptsPkg(): string {
        return this.PTS_PKG;
    }

    setTranslations = (translations: Record<string, string>) => (this.translations = translations);

    changeLocale = (locale: string) => {
        this.locale = locale;
    };
}
export const translationsStore = new TranslationsStore('ru');

export const TranslationsContext = createContext<TranslationsStore>(translationsStore);
export const useTranslationsContext = () => useContext<TranslationsStore>(TranslationsContext);
